import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/common/Primitives";
import { DataTable } from "@/components/common/DataTable";
import { Badge } from "@/components/ui/badge";
import { fmtDate } from "@/lib/format";
import { AlertTriangle } from "lucide-react";

const PRIO = { hoch: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20", normal: "bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/20", niedrig: "bg-muted text-muted-foreground border-border" };
const ST = { offen: "Offen", in_bearbeitung: "In Bearbeitung", erledigt: "Erledigt" };

export default function MfClaims() {
  const { data, isLoading } = useQuery({ queryKey: ["mf-reclamations"], queryFn: async () => (await api.get("/mobilfunk/reclamations")).data });
  const columns = [
    { key: "title", header: "Reklamation", render: (t) => (
      <div className="min-w-0"><div className="truncate font-medium">{t.title}</div>
        <div className="text-xs text-muted-foreground">{t.ref_label || "—"}{t.due_date ? ` · fällig ${fmtDate(t.due_date)}` : ""}</div></div>
    ) },
    { key: "assignee", header: "Zuständig", mobileHidden: true, render: (t) => t.assigned_user_name || "—" },
    { key: "priority", header: "Priorität", render: (t) => <Badge className={PRIO[t.priority] || PRIO.normal}>{t.priority}</Badge> },
    { key: "status", header: "Status", render: (t) => <Badge variant="outline">{ST[t.status] || t.status}</Badge> },
  ];
  return (
    <div data-testid="mf-claims">
      <PageHeader title="Differenzen & Reklamationen" description="Aus dem Soll-Ist-Abgleich erzeugte Aufgaben – verknüpft mit Abschluss und Beleg. Bearbeitung erfolgt im Aufgabenmodul." />
      <DataTable columns={columns} rows={data?.items} loading={isLoading} testIdPrefix="claim-row"
        empty={<EmptyState icon={AlertTriangle} title="Keine Reklamationen" description="Erzeugen Sie Aufgaben aus Abweichungen im Soll-Ist-Abgleich." />} />
    </div>
  );
}
